import { useCallback, useEffect, useState } from 'react';
import { hasFeatureBeenToggled } from '../../services/project-summary-onboarding/index.tsx';

export const useProjectSummaryFeatureStatus = (projectKey: string): boolean => {
	// We assume the feature has been toggled by default
	const [hasBeenToggled, setHasBeenToggled] = useState<boolean>(true);

	const fetchFeatureStatus = useCallback(async () => {
		const hasFeatureBeenTurnedOn = await hasFeatureBeenToggled(projectKey);
		setHasBeenToggled(hasFeatureBeenTurnedOn);
	}, [projectKey]);

	useEffect(() => {
		fetchFeatureStatus();
	}, [projectKey, fetchFeatureStatus]);

	return hasBeenToggled;
};
